import { makeVar } from '@apollo/client';

const featuresConfig = makeVar([]);
const isWebview = makeVar(false);
const appOs = makeVar(null);

const journeyHasError = makeVar(false);
const cartLocation = makeVar('CHECKOUT');
const selectedDeliveryMethod = makeVar('home');
const currentRoute = makeVar({
  stepId: null,
  stepIndex: null,
  stepName: '',
});

const userProps = makeVar({});
const ieShop = makeVar({});
const collectFromStores = makeVar({ stores: [], searchQuery: '' });
const deliveryProvider = makeVar('');

const isUpdateBackendCartLoadingVar = makeVar(false);
const redirectToGlobalE = makeVar(false);

const isEuDutyCurrencyIssue = makeVar(false);
const euDutyCountry = makeVar('');
const euDutyCurrency = makeVar('');
const euDutyCurrencySymbol = makeVar('');
const euDutyThresholdAmount = makeVar('');
const euDutyCountryCode = makeVar('');
// Holds the action to resume automatically once the EU duty modal clears
// (e.g. navigate to the store/shop the customer picked, or submit the
// address they were on) so the customer doesn't have to repeat their action
// after switching currency.
const euDutyContinueAction = makeVar(null);

export {
  appOs,
  cartLocation,
  collectFromStores,
  currentRoute,
  deliveryProvider,
  euDutyContinueAction,
  euDutyCountry,
  euDutyCountryCode,
  euDutyCurrency,
  euDutyCurrencySymbol,
  euDutyThresholdAmount,
  featuresConfig,
  ieShop,
  isEuDutyCurrencyIssue,
  isUpdateBackendCartLoadingVar,
  isWebview,
  journeyHasError,
  redirectToGlobalE,
  selectedDeliveryMethod,
  userProps,
};
